export default "__VITE_ASSET__BqnMR6Tr__"